import { useEffect, useState } from "react";
import api from "../../lib/api";
import ChangePasswordCard from "../../components/ChangePasswordCard";

export default function FranchiseSettings() {
  const [me, setMe] = useState(null);

  useEffect(() => {
    api.get("/franchise/me").then(({ data }) => setMe(data)).catch(() => {});
  }, []);

  const fr = me?.franchise || {};

  return (
    <div className="mx-auto max-w-2xl space-y-5" data-testid="franchise-settings-page">
      <h1 className="font-display text-2xl font-bold text-shipany-navy">Franchise Settings</h1>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-testid="franchise-profile-card">
        <h2 className="text-sm font-bold uppercase tracking-wide text-slate-500">Franchise Profile</h2>
        <dl className="mt-4 grid gap-3 text-sm sm:grid-cols-2">
          <div><dt className="text-xs text-slate-400">Franchise</dt><dd className="font-semibold text-shipany-navy">{fr.name || "—"}</dd></div>
          <div><dt className="text-xs text-slate-400">Code</dt><dd className="mono font-semibold text-shipany-navy" data-testid="franchise-code">{fr.franchise_code || "—"}</dd></div>
          <div><dt className="text-xs text-slate-400">Email</dt><dd className="font-semibold text-shipany-navy">{fr.email || "—"}</dd></div>
          <div><dt className="text-xs text-slate-400">Mobile</dt><dd className="font-semibold text-shipany-navy">{fr.mobile || "—"}</dd></div>
          <div><dt className="text-xs text-slate-400">City / State</dt><dd className="font-semibold text-shipany-navy">{[fr.city, fr.state].filter(Boolean).join(", ") || "—"}</dd></div>
          <div><dt className="text-xs text-slate-400">Status</dt><dd className="font-semibold capitalize text-shipany-navy" data-testid="franchise-settings-status">{fr.status || "—"}</dd></div>
        </dl>
        <p className="mt-4 text-[11px] text-slate-400">Profile changes are managed by ShipAny admin. Contact support to update franchise details.</p>
      </div>
      <ChangePasswordCard />
    </div>
  );
}
